import { render } from "./PoolIncome.vue?vue&type=template&id=fe61fcd8&scoped=true"
import script from "./PoolIncome.vue?vue&type=script&lang=js"
export * from "./PoolIncome.vue?vue&type=script&lang=js"

import "./PoolIncome.vue?vue&type=style&index=0&id=fe61fcd8&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe61fcd8"]])

export default __exports__